/* montreveUS · product page: variant + tier state, Buy 1 Get 1 bundles, gallery, sticky bar, hotspots. */
(() => {
  const wt = window.wt;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const money = (c) => wt.formatMoney(c);

  /* Tier maths. Mirrors the Liquid so the first paint and JS updates agree.
     Savings are always against qty × the regular price, never a compare-at anchor. */
  const tierTotals = (price, qty, discount) => {
    const regular = price * qty;
    const total = Math.round((regular * (100 - discount)) / 100);
    return { regular, total, per: Math.floor(total / qty), save: regular - total };
  };

  class WtProduct extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse($('[data-product-json]', this).textContent);
      this.form = $('[data-product-form]', this);
      this.bundleBox = $('[data-bundles]', this);
      const first = this.bundleBox && $('[data-bundle-pick="1"] wt-color-select', this.bundleBox);
      const id = Number(first ? first.dataset.value : $('[data-variant-input]', this).value);
      this.variant = this.data.variants.find((v) => v.id === id) || this.data.variants[0];
      this.tierIndex = Number(this.dataset.defaultTier || 1);
      if (!this.data.tiers.find((t) => t.index === this.tierIndex)) this.tierIndex = this.data.tiers.length ? this.data.tiers[0].index : 0;
      this.qty = 1;

      this.addEventListener('change', (e) => this.onChange(e));
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('wt:color-select', (e) => this.onPick(e.detail));
      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });
      this.selectTier(this.tierIndex, false);
      this.updateBundlePrice();
      // Open on the picture of the colour in the link (?variant=), not always on the first photo
      const gallery = $('wt-gallery', this);
      if (gallery && this.variant.media) {
        customElements.whenDefined('wt-gallery').then(() => requestAnimationFrame(() => gallery.goToMedia(this.variant.media, true)));
      }
    }

    get tier() { return this.bundleBox ? null : this.data.tiers.find((t) => t.index === this.tierIndex) || null; }

    /* The chosen bundle: how many watches, how many are free, and the extra % off the ones you pay for.
       The shop's automatic discounts give exactly this in the cart. */
    get bundle() {
      const r = this.bundleBox && $('[data-bundle-radio]:checked', this.bundleBox);
      if (!r) return null;
      return { qty: Number(r.dataset.qty), free: Number(r.dataset.free), extra: Number(r.dataset.extra), label: r.dataset.label };
    }

    bundleTotal(variants, b) {
      // With an extra % the shop runs one percentage off every watch, rounded per watch: mirror that to the cent
      if (b.extra > 0) {
        const keep = ((b.qty - b.free) / b.qty) * ((100 - b.extra) / 100);
        return variants.reduce((t, v) => t + Math.round(v.price * keep), 0);
      }
      const prices = variants.map((v) => v.price).sort((x, y) => y - x);
      const paid = prices.slice(0, b.qty - b.free).reduce((t, p) => t + p, 0);
      return Math.round((paid * (100 - b.extra)) / 100);
    }

    /* One variant per watch in the bundle, in order (1st watch, 2nd watch · Free, …) */
    pairVariants() {
      const b = this.bundle;
      return $$('[data-bundle-pick] wt-color-select', this.bundleBox).slice(0, b ? b.qty : 2).map((el) =>
        this.data.variants.find((v) => v.id === Number(el.dataset.value)) || this.variant);
    }

    onPick(detail) {
      const v = this.data.variants.find((x) => x.id === Number(detail.value));
      if (!v || !this.bundleBox) return;
      if (detail.slot === 1) this.setVariant(v);
      else {
        const gallery = $('wt-gallery', this);
        if (gallery && v.media) gallery.goToMedia(v.media);
        this.updateBundlePrice();
        this.updateButton();
        wt.emit('wt:variant-change', { product: this.data, variant: this.variant });
      }
      wt.track('pair_color', { product: this.data.id, unit: detail.slot, variant: v.id });
    }

    selectBundle(radio) {
      $$('[data-bundle-card]', this.bundleBox).forEach((c) => c.classList.toggle('is-selected', c.contains(radio)));
      const qty = Number(radio.dataset.qty);
      $$('[data-bundle-pick]', this.bundleBox).forEach((el) => { el.hidden = Number(el.dataset.bundlePick) > qty; });
      this.updateBundlePrice();
      this.updateButton();
      wt.track('bundle_selected', { product: this.data.id, qty });
      wt.emit('wt:tier-change', { tier: null, product: this.data, variant: this.variant });
    }

    updateBundlePrice() {
      if (!this.bundleBox) return;
      const b = this.bundle;
      const picks = this.pairVariants();
      const total = this.bundleTotal(picks, b);
      const was = picks.reduce((t, v) => t + v.price, 0);
      const each = money(Math.round(total / b.qty));
      const set = (sel, text) => { const el = $(sel, this); if (el) el.textContent = text; };
      set('[data-pair-total]', wt.strings.bundlePrice.replace('%count%', b.qty).replace('%price%', money(total)));
      set('[data-pair-was]', money(was));
      set('[data-pair-each]', (b.qty > 2 ? wt.strings.bundleNote4 : wt.strings.bundleNote2).replace('%price%', each).replace('%pct%', b.extra));
      // Bundle cards show the price for the colour of the 1st watch
      $$('[data-bundle-radio]', this.bundleBox).forEach((r) => {
        const card = { qty: Number(r.dataset.qty), free: Number(r.dataset.free), extra: Number(r.dataset.extra) };
        const same = Array(card.qty).fill(this.variant);
        const t = this.bundleTotal(same, card);
        set(`[data-bundle-total="${card.qty}"]`, money(t));
        set(`[data-bundle-was="${card.qty}"]`, money(this.variant.price * card.qty));
        set(`[data-bundle-each="${card.qty}"]`, wt.strings.bundleEach.replace('%price%', money(Math.round(t / card.qty))));
      });
    }

    onChange(e) {
      const t = e.target;
      if (t.matches('[data-option-index]')) {
        const chosen = $$('[data-option-index]:checked', this).sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex).map((i) => i.value);
        const match = this.data.variants.find((v) => v.options.every((o, i) => o === chosen[i]));
        if (match) this.setVariant(match);
        const label = $(`[data-option-value="${t.dataset.optionIndex}"]`, this);
        if (label) label.textContent = t.value;
      } else if (t.matches('[data-bundle-radio]')) {
        this.selectBundle(t);
      } else if (t.matches('.wt-tier__radio')) {
        this.selectTier(Number(t.value), true);
      } else if (t.matches('[data-unit]')) {
        const v = this.data.variants.find((x) => x.id === Number(t.value));
        wt.track('color_per_unit', { product: this.data.id, unit: Number(t.dataset.unit), variant: t.value, title: v && v.title });
      } else if (t.matches('[data-service]')) {
        const body = $(`[data-service-body="${t.dataset.service}"]`, this);
        if (body) body.hidden = !t.checked;
      }
    }

    onClick(e) {
      if (e.target.closest('[data-buy-one]')) { this.buyOne(e.target.closest('[data-buy-one]')); return; }
      const step = e.target.closest('[data-step]');
      if (step) {
        this.qty = Math.max(1, Math.min(10, this.qty + Number(step.dataset.step)));
        $('[data-qty-value]', this).textContent = this.qty;
        this.updateButton();
      }
    }

    selectVariantById(id) {
      const v = this.data.variants.find((x) => x.id === Number(id));
      if (!v) return;
      v.options.forEach((value, i) => {
        const input = $$(`[data-option-index="${i}"]`, this).find((n) => n.value === value);
        if (input) input.checked = true;
        const label = $(`[data-option-value="${i}"]`, this);
        if (label) label.textContent = value;
      });
      this.setVariant(v);
    }

    setVariant(v) {
      const prev = this.variant;
      this.variant = v;
      $('[data-variant-input]', this).value = v.id;

      const price = $('[data-price]', this);
      if (price) {
        $('[data-price-now]', price).textContent = money(v.price);
        const onSale = v.compare > v.price;
        $('[data-price-was]', price).hidden = !onSale;
        if (onSale) $('[data-price-was-value]', price).textContent = money(v.compare);
        const lowest = $('[data-price-lowest]', price);
        if (lowest) lowest.hidden = !onSale;
      }

      $$('[data-unit]', this).forEach((sel) => { if (Number(sel.value) === prev.id) sel.value = v.id; });
      $$('[data-tier-thumb]', this).forEach((el) => {
        if (v.thumb) el.innerHTML = `<img src="${v.thumb}" width="56" height="56" alt="" loading="lazy">`;
      });

      this.updateStock();
      this.updateBundlePrice();
      this.updateTierPrices();
      this.updateButton();
      const gallery = $('wt-gallery', this);
      if (gallery && v.media) gallery.goToMedia(v.media);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
      wt.emit('wt:variant-change', { product: this.data, variant: v });
    }

    selectTier(index, userAction) {
      this.tierIndex = index;
      $$('[data-tier]', this).forEach((card) => {
        const on = Number(card.dataset.tier) === index;
        card.classList.toggle('is-selected', on);
        const units = $('[data-units]', card);
        if (units) units.hidden = !on;
      });
      const tier = this.tier;
      const giftLine = $('[data-gift-line]', this);
      if (giftLine) {
        const gift = tier && tier.gift;
        giftLine.hidden = !gift;
        if (gift) $('[data-gift-text]', giftLine).textContent = gift;
      }
      this.updateButton();
      if (userAction) wt.track('tier_selected', { product: this.data.id, tier: index, qty: tier && tier.qty });
      wt.emit('wt:tier-change', { tier, product: this.data, variant: this.variant });
    }

    updateTierPrices() {
      $$('[data-tier]', this).forEach((card) => {
        const t = tierTotals(this.variant.price, Number(card.dataset.qty), Number(card.dataset.discount));
        const set = (sel, val) => { const el = $(sel, card); if (el) el.textContent = money(val); };
        set('[data-tier-total]', t.total);
        set('[data-tier-regular]', t.regular);
        set('[data-tier-per]', t.per);
        set('[data-tier-save]', t.save);
      });
    }

    currentTotal() {
      if (this.bundleBox) return this.bundleTotal(this.pairVariants(), this.bundle);
      const tier = this.tier;
      if (tier) return tierTotals(this.variant.price, tier.qty, tier.discount).total;
      return this.variant.price * this.qty;
    }

    currentQty() { return this.bundleBox ? this.bundle.qty : this.tier ? this.tier.qty : this.qty; }

    updateButton() {
      const btn = $('[data-atc]', this);
      if (!btn) return;
      const available = this.bundleBox ? this.pairVariants().every((v) => v.available) : this.variant.available;
      btn.disabled = !available;
      $('[data-atc-label]', btn).textContent = !available ? wt.strings.soldOut : this.bundleBox ? wt.strings.bundleAdd.replace('%count%', this.bundle.qty) : wt.strings.addToCart;
      const price = $('[data-atc-price]', btn);
      price.hidden = !available;
      price.textContent = `· ${money(this.currentTotal())}`;
      const qtyInput = $('[data-qty-hidden]', this);
      if (qtyInput) qtyInput.value = this.currentQty();
    }

    updateStock() {
      const box = $('[data-stock]', this);
      if (!box) return;
      const v = this.variant;
      const state = !v.available ? 'out' : v.low ? 'low' : 'in';
      box.className = `wt-pblock wt-stock wt-stock--${state}`;
      $('[data-stock-text]', box).textContent =
        state === 'out' ? wt.strings.soldOut : state === 'low' ? wt.strings.lowStock.replace('{count}', v.low) : wt.strings.inStock;
    }

    collectProperties() {
      const props = {};
      let error = null;
      $$('[data-service]:checked', this).forEach((box) => {
        const body = $(`[data-service-body="${box.dataset.service}"]`, this);
        $$('[data-prop]', body).forEach((input) => {
          if (!input.value.trim()) { error = input; return; }
          if (input.type === 'number' && !input.checkValidity()) { error = input; return; }
          props[input.dataset.prop] = input.value.trim();
        });
      });
      return { props, error };
    }

    collectAttributes() {
      const gift = $('[data-service="gift"]', this);
      if (!gift || !gift.checked) return null;
      const body = $('[data-service-body="gift"]', this);
      const attrs = {};
      $$('[data-attr]', body).forEach((el) => { if (el.value.trim()) attrs[el.dataset.attr] = el.value.trim(); });
      $$('[data-attr-check]', body).forEach((el) => { attrs[el.dataset.attrCheck] = el.checked ? 'Yes' : ''; });
      return attrs;
    }

    async buyOne(link) {
      const errorBox = $('[data-form-error]', this);
      link.classList.add('is-loading');
      try {
        await wt.cart.add([{ id: this.variant.id, quantity: 1 }]);
        wt.track('pair_buy_one', { product: this.data.id, variant: this.variant.id });
      } catch (err) {
        if (errorBox) { errorBox.textContent = err.message || wt.strings.cartError; errorBox.hidden = false; }
      } finally { link.classList.remove('is-loading'); }
    }

    async submit() {
      const btn = $('[data-atc]', this);
      const errorBox = $('[data-form-error]', this);
      if (!btn || btn.disabled) return;
      errorBox.hidden = true;

      const { props, error } = this.collectProperties();
      if (error) {
        errorBox.textContent = wt.strings.fillService;
        errorBox.hidden = false;
        error.focus();
        return;
      }

      const tier = this.tier;
      const qty = this.currentQty();
      const counts = new Map();
      const unitSelects = tier && tier.qty > 1 ? $$(`[data-tier="${tier.index}"] [data-unit]`, this) : [];
      if (this.bundleBox) this.pairVariants().forEach((v) => counts.set(v.id, (counts.get(v.id) || 0) + 1));
      else if (unitSelects.length) unitSelects.forEach((s) => counts.set(Number(s.value), (counts.get(Number(s.value)) || 0) + 1));
      else counts.set(this.variant.id, qty);
      const items = [...counts].map(([id, quantity]) => ({ id, quantity, properties: props }));

      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        await wt.cart.add(items, { tier: tier && tier.index, bundle: this.bundleBox ? this.bundle.qty : 0 });
        const attrs = this.collectAttributes();
        if (attrs) {
          await wt.cart.update({ attributes: attrs });
          wt.track('gift_option_used', { product: this.data.id });
        }
        if (Object.keys(props).length) wt.track('sizing_option_used', { product: this.data.id, services: Object.keys(props) });
      } catch (err) {
        errorBox.textContent = err.message || wt.strings.cartError;
        errorBox.hidden = false;
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('wt-product', WtProduct);

  /* ---------- Gallery: swipe + dots on mobile, thumbnails + zoom on desktop ---------- */
  class WtGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = $('[data-viewport]', this);
      this.slides = $$('.wt-gallery__slide', this);
      this.thumbs = $$('[data-go]', this);
      this.dots = $$('.wt-gallery__dot', this);
      this.thumbs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.go))));
      let raf;
      this.viewport.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.mark(Math.round(this.viewport.scrollLeft / this.viewport.clientWidth)));
      }, { passive: true });
      this.viewport.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.go(this.index + 1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { this.go(this.index - 1); e.preventDefault(); }
      });
      this.index = 0;
      if (this.dataset.zoom === 'true' && window.matchMedia('(hover: hover) and (min-width: 990px)').matches) this.enableZoom();
    }
    go(i, instant = false) {
      if (!this.slides.length) return;
      const index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.viewport.scrollTo({ left: index * this.viewport.clientWidth, behavior: instant ? 'auto' : 'smooth' });
      this.mark(index);
    }
    goToMedia(mediaId, instant = false) {
      const slide = this.slides.find((s) => Number(s.dataset.mediaId) === Number(mediaId));
      if (slide) this.go(this.slides.indexOf(slide), instant);
    }
    mark(i) {
      this.index = i;
      this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }
    enableZoom() {
      $$('.wt-gallery__frame', this).forEach((frame) => {
        const img = $('img', frame);
        if (!img) return;
        frame.classList.add('is-zoomable');
        frame.addEventListener('mousemove', (e) => {
          const r = frame.getBoundingClientRect();
          img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
          img.style.transform = 'scale(2)';
        });
        frame.addEventListener('mouseleave', () => { img.style.transform = ''; });
      });
    }
  }
  customElements.define('wt-gallery', WtGallery);

  /* ---------- Sticky add to cart ---------- */
  class WtStickyAtc extends HTMLElement {
    connectedCallback() {
      this.product = $('wt-product');
      const mainBtn = this.product && $('[data-atc]', this.product);
      if (!mainBtn) return;
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.hidden = !show;
        this.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('has-sticky', show);
      }).observe(mainBtn);
      $('[data-sticky-btn]', this).addEventListener('click', () => {
        wt.track('sticky_atc_click', { product: this.product.data.id });
        this.product.submit();
      });
      const select = $('[data-sticky-variant]', this);
      if (select) select.addEventListener('change', () => this.product.selectVariantById(select.value));
      wt.on('wt:variant-change', () => this.sync());
      wt.on('wt:tier-change', () => this.sync());
      this.sync();
    }
    sync() {
      const p = this.product;
      if (!p || !p.variant) return;
      const v = p.variant;
      const tier = p.tier;
      const btn = $('[data-sticky-btn]', this);
      btn.disabled = !v.available;
      $('[data-sticky-label]', this).textContent = v.available ? wt.strings.addToCart : wt.strings.soldOut;
      $('[data-sticky-price]', this).textContent = `· ${money(p.currentTotal())}`;
      const tierEl = $('[data-sticky-tier]', this);
      if (p.bundleBox) {
        const b = p.bundle;
        tierEl.textContent = wt.strings.bundleSticky.replace('%label%', b.label).replace('%count%', b.qty);
        $('[data-sticky-label]', this).textContent = v.available ? wt.strings.bundleAdd.replace('%count%', b.qty) : wt.strings.soldOut;
      } else if (tier && tier.qty > 1) {
        tierEl.textContent = `${tier.label} · ${money(tierTotals(v.price, tier.qty, tier.discount).per)} ${wt.strings.perWatch}`;
      } else {
        tierEl.textContent = v.title === 'Default Title' ? '' : v.title;
      }
      const select = $('[data-sticky-variant]', this);
      if (select) {
        select.value = v.id;
        const wrap = $('[data-sticky-variant-wrap]', this);
        wrap.hidden = Boolean((tier && tier.qty > 1) || p.bundleBox);
      }
      if (v.thumb) $('[data-sticky-thumb]', this).innerHTML = `<img src="${v.thumb}" width="48" height="48" alt="" loading="lazy">`;
    }
  }
  customElements.define('wt-sticky-atc', WtStickyAtc);

  /* ---------- Anatomy hotspots ---------- */
  class WtHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-target]');
        if (!dot) return;
        const card = document.getElementById(dot.dataset.target);
        if (!card) return;
        $$('.wt-acard', this).forEach((c) => c.classList.toggle('is-active', c === card));
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }
  }
  customElements.define('wt-hotspots', WtHotspots);
})();
